import { render } from "./Plus.vue?vue&type=template&id=32e0aca8"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Plus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "32e0aca8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32e0aca8', __exports__)) {
    api.reload('32e0aca8', __exports__)
  }
  
  module.hot.accept("./Plus.vue?vue&type=template&id=32e0aca8", () => {
    api.rerender('32e0aca8', render)
  })

}


export default __exports__